import moment from 'moment';

class DatesService {
  format(dateString: string, format = 'Do MMMM YYYY HH:mm'): string {
    try {
      return moment(dateString).format(format);
    } catch {
      return '[Invalide]';
    }
  }

  parse(dateString: string, format = 'Do MMMM YYYY HH:mm'): Date {
    return moment(dateString, format).toDate();
  }

  add(dateString: string, time: number, type, format = 'YYYY-MM-DD HH:mm Z'): string {
    return moment(dateString, format).add(time, type).toISOString();
  }

  today(): string {
    return moment().toISOString();
  }

  before(dateString: string, beforeDateString: string): boolean {
    return moment(dateString, 'YYYY-MM-DD HH:mm Z').isSameOrBefore(beforeDateString);
  }

  diff(date1: string, date2: string): number {
    const DATE1 = moment(date1, 'YYYY-MM-DD HH:mm:ss Z');
    const DATE2 = moment(date2, 'YYYY-MM-DD HH:mm:ss Z');
    return parseFloat(DATE2.diff(DATE1, 'minutes', true).toFixed(2));
  }

  /* Jours fériés français (fixes + mobiles calculés depuis Pâques), même calendrier que la gem
     holidays :fr côté backend (le lundi de Pentecôte n'en fait pas partie). */
  frenchHolidays(year: number): string[] {
    const easter = this.easterSunday(year);
    const shifted = (days: number) => moment(easter).add(days, 'days').format('YYYY-MM-DD');
    return [
      `${year}-01-01`,
      `${year}-05-01`,
      `${year}-05-08`,
      `${year}-07-14`,
      `${year}-08-15`,
      `${year}-11-01`,
      `${year}-11-11`,
      `${year}-12-25`,
      shifted(1), // lundi de Pâques
      shifted(39) // Ascension
    ];
  }

  isBusinessDay(date: moment.Moment): boolean {
    const day = date.isoWeekday();
    if (day >= 6) return false;
    return !this.frenchHolidays(date.year()).includes(date.format('YYYY-MM-DD'));
  }

  /* Dernier jour ouvré strictement avant `date` (un lundi → vendredi, lendemain de férié → veille) */
  previousBusinessDay(date: moment.Moment = moment()): moment.Moment {
    const d = moment(date).startOf('day');
    do d.subtract(1, 'day');
    while (!this.isBusinessDay(d));
    return d;
  }

  /* Algorithme de Meeus/Jones/Butcher (calendrier grégorien) */
  private easterSunday(year: number): moment.Moment {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return moment({ year, month: month - 1, day });
  }
}

export const datesService = new DatesService();
